import React from "react";

function Footer(){
    return(
        <div className="footer">
            <p>Remember Todo list 2024</p>
        </div>
    );
}
export default Footer